<template>
  <div :class="['search-box', {'no-tab':!charter.globalEnabled && !d2dEnabled}]">
    <!-- TABS -->
    <div class="d-flex widget-new-tab" v-if="confEnv === 'development'">
      <div :class="['wn-tab', {active: widgetTab === 'flight'}]" @click="redirectNEW('flight')"
      @mouseover="tabHover('flight')" @mouseleave="tabHoverOut">
        Book A Flight
        <span :class="['tp-msg txt-left txt-d2d', {active:tooltip.active === 'flight'}]">
          Book your flight for a seamless, stress-free ride to your destination!
        </span>
      </div>
      <div :class="['wn-tab', {active: widgetTab === 'd2d'}]" @click="redirectNEW('d2d')" @mouseover="tabHover('d2d')" @mouseleave="tabHoverOut">
        Book Flight + Ride
        <span :class="['tp-msg txt-left txt-d2d', {active:tooltip.active === 'd2d'}]">
          Experience seamless Door2Door travel, where flights and ground transportation combine for effortless, end-to-end journeys. Book now!
        </span>
      </div>
      <div :class="['wn-tab', {active: widgetTab === 'ground'}]" @click="redirectNEW('ground')"
      @mouseover="tabHover('ground')" @mouseleave="tabHoverOut">
        Book A Ride
        <span :class="['tp-msg txt-left txt-d2d', {active:tooltip.active === 'ground'}]">
          Book your ground transportation for a seamless, stress-free ride from home, office, or anywhere to your destination!
        </span>
      </div>
      <div :class="['wn-tab', {active: widgetTab === 'track'}]" @click="redirectNEW('track')" v-if="!user.token" @mouseover="tabHover('track')" @mouseleave="tabHoverOut">
        Track Reservation
        <span :class="['tp-msg', {active:tooltip.active === 'track'}]">Track your reservation here!</span>
      </div>
      <div :class="['wn-tab', {active: widgetTab === 'manage'}]" @click="getFlights" @mouseover="tabHover('manage')" v-else>
        Manage your Booking
        <span :class="['tp-msg', {active:tooltip.active === 'manage'}]">Manage your Booking here!</span>
      </div>
    </div>

    <!-- HEAD OPTIONS -->
    <div class="d-flex new-top nt-parent align-center">
      <div class="lr-desc-mobile d-flex justify-space-between">
        <div class="mobile-acc-box" v-if="!user.token">
          <a @click="showGlobalLogin">Login</a>
          <span>|</span>
          <a @click="showGlobalSignup">Sign Up</a>
        </div>
        <a @click="getFlights" class="mng-flights" v-else>
          <i class="fas fa-plane fa-fw"></i>
          My Trips
        </a>

        <select class="currency" v-model="currency" aria-label="Select Currency" :disabled="currencyStore.loading || !Object.keys(currencyStore.list).length" v-if="['d2d', 'flight', 'ground'].indexOf(widgetTab) > -1">
          <option value="USD">$ (USD)</option>
          <option value="INR">{{ currencySymbol.INR }} (INR)</option>
          <option value="CAD">{{ currencySymbol.CAD }} (CAD)</option>
          <option value="EUR">{{ currencySymbol.EUR }} (EUR)</option>
          <option value="GBP">{{ currencySymbol.GBP }} (GBP)</option>
          <option value="JPY">{{ currencySymbol.JPY }} (JPY)</option>
          <option value="CNY">{{ currencySymbol.CNY }} (CNY)</option>
          <option value="AUD">{{ currencySymbol.AUD }} (AUD)</option>
          <option value="AED">{{ currencySymbol.AED }} (AED)</option>
          <option value="MXN">{{ currencySymbol.MXN }} (MXN)</option>
          <option value="PHP">{{ currencySymbol.PHP }} (PHP)</option>
        </select>
      </div>

      <div class="mob-order-3 d-flex align-center" v-if="['d2d', 'flight'].indexOf(widgetTab) > -1">
        <select v-model="booking.filters.departure.isReturning" @change="tripTypeUpdate">
          <option :value="false">One Way</option>
          <option :value="true">Round Trip</option>
        </select>
      </div>
      <div class="welcome-txt" v-if="user.token">
        <div>
          Welcome, 
          <b @click="showUserInfo" class="user-x">{{ user.firstName }}</b>!
          <a @click="getFlights" class="mng-flights">
            <i class="fas fa-plane fa-fw"></i>
            My Trips
          </a>
        </div>
        <a @click="logout" class="logout">Logout</a>
      </div>
      <div class="d-flex new-top align-center mob-order-1" v-if="!user.token">
        <div v-if="!user.token">
          <span>Already have an account?</span>
          <a @click="showGlobalLogin">Login</a>
        </div>
        <div v-if="!user.token">
          <span>Don't have an account?</span>
          <a @click="showGlobalSignup">Sign Up</a>
        </div>
      </div>
      <div class="margin-l-a hide-in-mobile">
        <select class="currency desktop-mode" v-model="currency" aria-label="Select Currency" :disabled="currencyStore.loading || !Object.keys(currencyStore.list).length" v-if="['d2d', 'flight', 'ground'].indexOf(widgetTab) > -1">
          <option value="USD">$ (USD)</option>
          <option value="INR">{{ currencySymbol.INR }} (INR)</option>
          <option value="CAD">{{ currencySymbol.CAD }} (CAD)</option>
          <option value="EUR">{{ currencySymbol.EUR }} (EUR)</option>
          <option value="GBP">{{ currencySymbol.GBP }} (GBP)</option>
          <option value="JPY">{{ currencySymbol.JPY }} (JPY)</option>
          <option value="CNY">{{ currencySymbol.CNY }} (CNY)</option>
          <option value="AUD">{{ currencySymbol.AUD }} (AUD)</option>
          <option value="AED">{{ currencySymbol.AED }} (AED)</option>
          <option value="MXN">{{ currencySymbol.MXN }} (MXN)</option>
          <option value="PHP">{{ currencySymbol.PHP }} (PHP)</option>
        </select>
        <a @click="logout" class="logout" v-if="user.token">Logout</a>
      </div>
    </div>

    <!-- LANGUAGE -->
    <div class="lr-desc" v-if="false">
      <div class="lang-box">
        <select class="currency" v-model="currency" aria-label="Select Currency" :disabled="currencyStore.loading || !Object.keys(currencyStore.list).length" v-if="route !== 'RsvpEdit'">
          <option value="USD">USD (USD)</option>
          <option value="INR">{{ currencySymbol.INR }} (INR)</option>
          <option value="CAD">{{ currencySymbol.CAD }} (CAD)</option>
          <option value="EUR">{{ currencySymbol.EUR }} (EUR)</option>
          <option value="GBP">{{ currencySymbol.GBP }} (GBP)</option>
          <option value="JPY">{{ currencySymbol.JPY }} (JPY)</option>
          <option value="CNY">{{ currencySymbol.CNY }} (CNY)</option>
          <option value="AUD">{{ currencySymbol.AUD }} (AUD)</option>
          <option value="AED">{{ currencySymbol.AED }} (AED)</option>
          <option value="MXN">{{ currencySymbol.MXN }} (MXN)</option>
          <option value="PHP">{{ currencySymbol.PHP }} (PHP)</option>
        </select>
      </div>

      <span v-if="!charter.globalEnabled && false">{{ $t('searchForm.bookARide') }}</span>
    </div>

    <div :class="['abs-center-container', {'show-on-load':showOnLoad}]" v-if="!hideSearchForm">
      <div class="abs-center">

        <transition name="slide-down" appear>
          <div :class="['medium-margin-v-s', {'card':!showOnLoad }]">
            <div class="row panel full-width" style="margin: 0 auto">
              <div class="medium-12 column top-part" v-if="!showOnLoad">
                <span class="search-cancel" @click="cancel">
                  <i class="fas fa-chevron-left"></i> {{ $t('common.cancel') }}
                </span>
              </div>

              <transition name="slide-down-small">
                <div class="medium-12 column quote-error" v-if="!!quoteErrorMsg">{{ quoteErrorMsg }}</div>
              </transition>

              <div v-show="['flight', 'd2d'].indexOf(widgetTab) > -1" style="width: 100%;padding: 0;">
                <d2d-widget ref="d2dWidget" @forceGround="forceGround"/>
              </div>

              <!-- <div v-show="widgetTab === 'flight'" style="width: 100%;padding: 0;">
                <flight-widget ref="flightWidget"/>
              </div> -->

              <div v-show="widgetTab === 'ground'" style="width: 100%;padding: 0;">
                <ground-widget ref="groundWidget" />
              </div>

              <div v-show="widgetTab === 'track'" style="width: 100%;padding: 0;">
                <tracking-widget />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <login-signup></login-signup>
    <departure-modal @newDate="newDate"></departure-modal>
    <map-modal ref="mapModal" @change="mapNewValue"></map-modal>
    <!-- <departure-modal></departure-modal> -->
    <!-- <travellers-modal></travellers-modal> -->
    <first-time-modal @proceed="continueBooking"></first-time-modal>

    <transition name="slide-down">
      <driver-review v-if="showDriverReviewForm"></driver-review>
    </transition>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import moment from 'moment'
import LocationInput from './LocationInput'
import LoginSignup from './LoginSignupModal'
import DriverReview from '@/components/DriverReview'
import ApiQuote from '@/modules/api/quote'
import ApiAds from '@/modules/api/ads'
// import ApiPickupType from '@/modules/api/pickup-type'
import ApiRsvpSearch from '@/modules/api/reservation-search'
// import DateTimePicker from '@/components/ServiceSelection/DateTimePicker'
import MapModal from './MapModal'
import FirstTimeModal from './FirstTimeModal'
import WidgetSession from '@/modules/session'

import DepartureModal from './DateTimePicker'
import D2DWidget from './D2DFlight'
import FlightWidget from './Flight'
import GroundWidget from './Ground'
import TrackingWidget from './Tracking'
import currencySymbol from '@/data/currency.js'
// import currencyCountry from '@/data/currency-country.js'
import airlines from '@/data/airlines.js'

const cookie = require('vue-cookie')
// const airportTimezone = require('airport-timezone')

export default {
  name: 'search-form',
  components: { LocationInput, LoginSignup, DriverReview, DepartureModal, MapModal, 'd2d-widget': D2DWidget, FlightWidget, GroundWidget, TrackingWidget, FirstTimeModal },
  data () {
    return {
      pickup: '',
      dropoff: '',
      pickupText: '',
      dropoffText: '',
      pickupPlaceId: null,
      dropoffPlaceId: null,
      timezoneLoading: false,
      quotationLoading: false,
      validation: {
        pickup: '',
        dropoff: ''
      },
      quoteErrorMsg: '',
      quoteDelay: '',
      airportListLoading: false,
      showOnLoad: false,
      widgetTab: 'flight',
      charterLocation: {
        pickup: '',
        pickupText: '',
        pickupPlaceId: null,
        validation: ''
      },
      charterValidation: {
        startDate: '',
        endDate: ''
      },
      highlight: '',
      d2dQueue: [],
      d2dValidation: {
        date: ''
      },
      d2dFlightLoading: false,
      session: '',
      // authRender: true,
      track: {
        pnr: '',
        firstName: '',
        lastName: '',
        validation: {
          pnr: '',
          firstName: '',
          lastName: ''
        }
      },
      widgetErrorRemover: '',
      // showLoggedInOptions: false,
      lastPickup: '',
      lastDropoff: '',
      currencySymbol: currencySymbol,
      tooltip: {
        active: '',
        delay: ''
      },
      confEnv: CONFIG.Env
    }
  },
  computed: {
    user () { return this.$store.state.user },
    rsvpData () { return this.$store.state.reservation },
    _pickup () { return this.rsvpData.leg1.pickup.title },
    _dropoff () { return this.rsvpData.leg1.dropoff.title },
    pickupExtra () {
      return {
        brandId: 13,
        field: 'pickup',
        placeholder: 'Enter your pickup location'
        // placeholder: this.$t('searchForm.locationPlaceholder')
      }
    },
    dropoffExtra () {
      return {
        brandId: 13,
        field: 'dropoff',
        // placeholder: this.$t('searchForm.locationPlaceholder'),
        placeholder: 'Enter your Dropoff location e.g. Home,Hotel etc.',
        error: this.validation.dropoff
      }
    },
    airlineLoading () { return this.$store.state.reservation.airlineLoading },
    buttonLoading () { return this.timezoneLoading || this.quotationLoading || this.airlineLoading },
    _homePageTracked () { return this.$store.state.tracking.homePageTracked },
    _brandId () { return this.$store.state.brandId },
    brandCode () { return this.$store.state.brandCode },
    route () { return this.$route.name },
    currentBrand () { return this.$store.state.brandCode },
    isLogin () { return !!this.user.email },
    isCorporate () { return this.user.isCorporate },
    loggedInUser () { return this.user.firstName },
    showDriverReviewForm () { return this.$store.state.driverReview.modal },
    hideSearchForm () { return this.$store.state.driverReview.searchForm },
    extraStop () { return this.$store.state.reservation.extraStop },
    charter () { return this.rsvpData.charter },
    pickupCharterExtra () {
      return {
        field: 'charter',
        placeholder: this.$t('searchForm.locationPlaceholder')
      }
    },
    _charterPickup () { return this.charter.pickup.title },
    chaterStartDate () { return this.charter.startDate },
    chaterEndDate () { return this.charter.endDate },
    webTimeBuffer () { return this.$store.state.reservation.webTimeBuffer },
    mtech () { return this.$store.state.reservation.mtech },
    lang: {
      get () { return this.$i18n.locale },
      set (val) {
        localStorage.setItem('widgetLang', val)
        this.$store.commit('setProgressLabel', [
          this.$t('progressbar.chooseRide'),
          this.$t('progressbar.enterDetails'),
          this.$t('progressbar.paymentDetails'),
          this.$t('progressbar.reviewBook')
        ])
        // let url = window.location
        // window.location = url.href.split(url.hash)[0]
        location.reload()
      }
    },
    initAirportPickup () { return this.rsvpData.initAirportPickup },
    opoliCnsData () { return this.$store.state.tracking.opoliCNS },
    d2dEnabled () { return CONFIG.featureToggle.d2dBooking },
    d2d () { return this.$store.state.reservation.d2d },
    departureDate () {
      let date1 = moment(this.d2d.departure.date, 'MM/DD/YYYY').format('MMM DD')
      if (this.d2d.departure.isReturning) {
        let date2 = moment(this.d2d.departure.return, 'MM/DD/YYYY').format('MMM DD')
        return `${date1} - ${date2}`
      }
      return date1
    },
    d2dTimeBuffer () { return this.d2d.settings.timeBuffer },
    other () { return this.$store.state.other },
    currencyStore () { return this.other.currency },
    currency: {
      get () { return this.currencyStore.code },
      set (val) {
        // localStorage.setItem('widgetLang', val)
        this.$store.commit('other/setCurrencyData', {code: val})
        this.updateCurrencyValue()

        if (window.gtag) { // eslint-disable-line
          gtag( // eslint-disable-line
            'event',
            'Currency',
            {value: val}
          )
        }
      }
    },
    booking () { return this.$store.state.booking },
    locations () { return this.booking.locations }
  },
  methods: {
    loginSignup () {
      let self = this
      self.$store.commit('loginSignup/showModal')
      document.getElementsByTagName('body')[0].setAttribute('style', 'overflow: hidden!important;')
      document.body.classList.add('widget-no-scroll')
      if (document.querySelectorAll('.top-bar.dynamic')[0]) {
        document.querySelectorAll('.top-bar.dynamic')[0].setAttribute('style', 'z-index:2;')
      }
      if (document.querySelectorAll('#desktopMenu')[0]) {
        document.querySelectorAll('#desktopMenu')[0].setAttribute('style', 'z-index:100;')
        document.querySelectorAll('#mobileMenu')[0].setAttribute('style', 'z-index:100;')
      }
    },
    validateGeo (event = null, leg = 'leg1') {
      if (event) event.preventDefault()
      let self = this
      self.$store.commit('other/setOtherData', {startErrorLog: true})
      // try {
      let hasError = false
      if (self.widgetTab === 'mileage') {
        if (!self.pickupText || !self.dropoffText) {
          if (!self.pickupText || self.pickupText.trim() === '') {
            self.validation.pickup = this.$t('common.fieldEmpty')
          }
          if (!self.dropoffText || self.dropoffText.trim() === '') {
            self.validation.dropoff = this.$t('common.fieldEmpty')
          }
          hasError = true
        }
        self.extraStop.leg1.forEach(stop => {
          if (!stop.text) {
            self.$store.commit('reservation/setExtraStopData', {
              leg: leg,
              id: stop.id,
              fields: { error: this.$t('common.fieldEmpty') }
            })
            hasError = true
          }
        })
      }
      if (self.widgetTab === 'charter') {
        if (!self.charterLocation.pickupText || self.charterLocation.pickupText.trim() === '') {
          self.charterLocation.validation = this.$t('common.fieldEmpty')
          hasError = true
        }
        if (!self.charter.startDate) {
          self.charterValidation.startDate = this.$t('common.fieldEmpty')
          hasError = true
        }
        if (!self.charter.endDate) {
          self.charterValidation.endDate = this.$t('common.fieldEmpty')
          hasError = true
        }
        let startDate = moment(self.charter.startDate, 'MM/DD/YYYY hh:mmA')
        let endDate = moment(self.charter.endDate, 'MM/DD/YYYY hh:mmA')
        let WebTimeBuffer = this.webTimeBuffer
        if (self.charter.startDate && startDate.diff(moment().add(WebTimeBuffer, 'minutes')) <= 0) {
          self.charterValidation.startDate = this.$t('searchForm.startDateGreater', {WebTimeBuffer: WebTimeBuffer})
          hasError = true
        }
        if (self.charter.startDate && self.charter.endDate && startDate.diff(endDate, 'minutes') > 0) {
          self.charterValidation.endDate = this.$t('common.endDateMust')
          hasError = true
        }
        if (self.charter.startDate && self.charter.endDate && endDate.diff(startDate, 'minutes') > self.charter.maxDuration) {
          let time = moment.duration(self.charter.maxDuration, 'minutes').humanize({h: Infinity})
          self.charterValidation.endDate = this.$t('common.maxDurationCharter', {time: time})
          hasError = true
        }
        if (self.charter.startDate && self.charter.endDate && self.charter.startDate === self.charter.endDate) {
          self.charterValidation.startDate = this.$t('common.invalidDateRange')
          self.charterValidation.endDate = this.$t('common.invalidDateRange')
          hasError = true
        }
      }
      if (CONFIG.Env == 'production' && window.gtag && self.$store.state.brandCode == 'op') { // eslint-disable-line
        gtag('event', 'Get a Quote', {}) // eslint-disable-line
      }
      if (hasError) { return }

      setTimeout(function () {
        self.quotationLoading = true
        let promises = []
        if (self.widgetTab === 'mileage') {
          // Validate pickup location geocode
          promises.push(
            new Promise((resolve, reject) => {
              if (self.rsvpData.leg1.pickup.title !== self.pickupText) {
                self.$once('pickupChange', function () { clearTimeout(timeout); resolve(); })
                let timeout = setTimeout(function () { reject(new Error('Timeout')) }, 5000)
                self.geocode(self.pickupText.trim(), 'pickup', geocodeResult => {
                  if (geocodeResult) {
                    self.pickupPlaceId = geocodeResult.place_id
                  } else {
                    reject(new Error(self.$t('searchForm.manualPickup')))
                  }
                })
              } else {
                resolve()
              }
            }).catch(err => {
              self.validation.pickup = self.$t('searchForm.unablePinpointPickup')
              if (!self.pickupText || self.pickupText.trim() === '') {
                self.validation.pickup = self.$t('common.fieldEmpty')
              }
              return Promise.reject(err)
            })
          )
          self.extraStop.leg1.forEach(stop => {
            promises.push(
              // Validate Extra Stop location geocode
              new Promise((resolve, reject) => {
                if (stop.location.title !== stop.text) {
                  self.$once('extraStopChange', function () { clearTimeout(timeout); resolve(); })
                  let timeout = setTimeout(function () { reject(new Error('Timeout')) }, 5000)
                  self.geocode(stop.text.trim(), 'extraStop', geocodeResult => {
                    if (geocodeResult) {
                      self.$store.commit('reservation/setExtraStopData', {
                        leg: 'leg1',
                        id: stop.id,
                        fields: { placeId: geocodeResult.place_id }
                      })
                    } else {
                      reject(new Error(self.$t('searchForm.manualLocation')))
                    }
                  })
                } else {
                  resolve()
                }
              }).catch(err => {
                let msg = self.$t('searchForm.unablePinpointExtra')
                if (!stop.text || stop.text.trim() === '') {
                  msg = self.$t('common.fieldEmpty')
                }
                self.$store.commit('reservation/setExtraStopData', {
                  leg: 'leg1',
                  id: stop.id,
                  fields: { error: msg }
                })
                return Promise.reject(err)
              })
            )
          })
          promises.push(
            // Validate dropoff location geocode
            new Promise((resolve, reject) => {
              if (self.rsvpData.leg1.dropoff.title !== self.dropoffText) {
                self.$once('dropoffChange', function () { clearTimeout(timeout); resolve(); })
                let timeout = setTimeout(function () { reject(new Error('Timeout')) }, 5000)
                self.geocode(self.dropoffText.trim(), 'dropoff', geocodeResult => {
                  if (geocodeResult) {
                    self.dropoffPlaceId = geocodeResult.placeId
                  } else {
                    reject(new Error(self.$t('searchForm.manualDropoff')))
                  }
                })
              } else {
                resolve()
              }
            }).catch(err => {
              self.validation.dropoff = self.$t('searchForm.unablePinpointDropoff')
              if (!self.dropoffText || self.dropoffText.trim() === '') {
                self.validation.dropoff = self.$t('common.fieldEmpty')
              }
              return Promise.reject(err)
            })
          )
        }
        if (self.widgetTab === 'charter') {
          promises.push(
            new Promise((resolve, reject) => {
              if (self.rsvpData.charter.pickup.title !== self.charterLocation.pickupText) {
                self.$once('charterPickupChange', function () { clearTimeout(timeout); resolve(); })
                let timeout = setTimeout(function () { reject(new Error('Timeout')) }, 5000)
                self.geocode(self.charterLocation.pickupText.trim(), 'charter', geocodeResult => {
                  if (geocodeResult) {
                    self.charterLocation.pickupPlaceId = geocodeResult.place_id
                  } else {
                    reject(new Error(self.$t('searchForm.manualPickup')))
                  }
                })
              } else {
                resolve()
              }
            }).catch(err => {
              self.charterLocation.validation = self.$t('searchForm.unablePinpointPickup')
              if (!self.charterLocation.pickupText || self.charterLocation.pickupText.trim() === '') {
                self.charterLocation.validation = self.$t('common.fieldEmpty')
              }
              return Promise.reject(err)
            })
          )
        }
        Promise.all(promises)
          .then(function () {
            // self.quotationLoading = false
            if (self.quoteDelay) { clearTimeout(self.quoteDelay) }
            self.quoteDelay = setTimeout(function () {
              self.submit()
            }, 500)
          })
          .catch(err => {
            self.quotationLoading = false
            console.log(err)
          })
      }, 200)
    },
    geocode (addressStr, field, callback) {
      let self = this
      const restrictedTypes = [
        'locality', 'postalCodePoint', 'administrativeArea',
        'chainQuery', 'categoryQuery'
      ]
      let suggestedLoc = { lat: 33.942791, lng: -118.410042 } // LAX
      if (window.location.href.indexOf('primetimeshuttle') > -1 &&
        (self.$store.state.brandId === 15 || self.$store.state.brandId === 6)
      ) {
        suggestedLoc = { lat: 13.4451379, lng: -89.0592244 } // El Salvador
      }
      let pickup = self.$store.state.reservation.leg1.pickup
      if (['extraStop', 'droff'].indexOf(field) > -1 && pickup.lat) {
        suggestedLoc = { lat: pickup.lat, lng: pickup.lng }
      }

      let url = 'https://discover.search.hereapi.com/v1/discover?at={AT}&q={SEARCH}&apiKey={API_KEY}'
      url = url.replace('{AT}', encodeURIComponent(suggestedLoc.lat + ',' + suggestedLoc.lng))
        .replace('{SEARCH}', addressStr)
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err || !body.items || body.items.length === 0) { // eslint-disable-line no-undef
          return false
        }

        let result = []
        body.items.forEach(function (prediction) {
          if (restrictedTypes.indexOf(prediction.resultType) === -1) {
            result.push({
              id: prediction.id,
              title: prediction.title,
              subtitle: '',
              icon: 'fa-map-marker'
            })
          }
        })

        if (!result.length) {
          return false
        } else {
          let url = 'https://lookup.search.hereapi.com/v1/lookup?source=sharing&id={LOCATION_ID}&locationattributes=tz&apiKey={API_KEY}'
          url = url.replace('{LOCATION_ID}', result[0].id)
            .replace('{API_KEY}', CONFIG.hereApi.key)
          request.get({
            url: url,
            json: true
          }, function (err, res, body) {
            if (err) { return false }
            callback(body)
          })
        }
      })
    },
    submit () {
      // validator
      let self = this

      self.validation.pickup = ''
      self.validation.extraStop = ''
      self.validation.dropoff = ''
      let hasError = false
      if (!self.charter.enabled) {
        if (self.pickupText.trim() === '') {
          hasError = true
          this.validation.pickup = self.$t('common.fieldEmpty')
        }
        self.extraStop.leg1.forEach(stop => {
          if (stop.text.trim() === '') {
            hasError = true
            self.$store.commit('reservation/setExtraStopData', {
              leg: 'leg1',
              id: stop.id,
              fields: { error: self.$t('common.fieldEmpty') }
            })
          }
        })
        if (self.dropoffText.trim() === '') {
          hasError = true
          self.validation.dropoff = self.$t('common.fieldEmpty')
        }
      } else {
        if (self.charterLocation.pickupText.trim() === '') {
          hasError = true
          self.charterLocation.validation = self.$t('common.fieldEmpty')
        }
        if (!self.charter.startDate) {
          self.charterValidation.startDate = self.$t('common.fieldEmpty')
          hasError = true
        }
        if (!self.charter.endDate) {
          self.charterValidation.endDate = self.$t('common.fieldEmpty')
          hasError = true
        }
        let startDate = moment(self.charter.startDate, 'MM/DD/YYYY hh:mmA')
        let endDate = moment(self.charter.endDate, 'MM/DD/YYYY hh:mmA')
        let WebTimeBuffer = this.webTimeBuffer
        if (self.charter.startDate && startDate.diff(moment().add(WebTimeBuffer, 'minutes')) <= 0) {
          self.charterValidation.startDate = self.$t('searchForm.startDateGreater', {WebTimeBuffer: WebTimeBuffer})
          hasError = true
        }
        if (self.charter.startDate && self.charter.endDate && startDate.diff(endDate, 'minutes') > 0) {
          self.charterValidation.endDate = self.$t('common.endDateMust')
          hasError = true
        }
      }
      if (self.widgetTab === 'd2d') {
        if (!self.d2d.departure.date) {
          hasError = true
          self.d2dValidation.date = self.$t('common.fieldEmpty')
        }
      }

      if (hasError) {
        self.quotationLoading = false
        return
      }

      if (self.widgetTab === 'd2d') {
        if (self.rsvpData.leg1.isAirportPickup || self.rsvpData.leg1.isAirportDropoff) {
          self.$store.commit('global/setAlertData', {show: true, message: 'Airport location is not allowed. Please adjust your search and enter the address to be picked up from.'})
          self.quotationLoading = false
          return
        }

        self.$store.commit('other/setOtherData', {
          appLoader: true,
          appLoaderMsg: ''
        })

        self.d2dQueue = ['getAirports', 'pickupNearestAirport', 'dropoffNearestAirport', 'getFlight']
        self.d2dProcess()
        return
      }

      this.timezoneLoading = true
      let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={AT}&lang=en-US&apiKey={API_KEY}&show=tz'
      let pickup = self.charter.enabled ? self.charter.pickup : this.rsvpData.leg1.pickup
      url = url.replace('{AT}', encodeURIComponent(pickup.lat + ',' + pickup.lng))
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        // Default to LA
        self.$store.commit('reservation/setTimezone', { leg: 'leg1', value: 'America/Los_Angeles' })
        if (err) { console.log(err) }
        self.timezoneLoading = false
        if (body.items.length) {
          self.$store.commit('reservation/setTimezone', {leg: 'leg1', value: body.items[0].timeZone.name})
        } else {
          console.log('Zero results on GET TIMEZONE')
        }
      })

      let pickupDate = this.rsvpData.leg1.pickupDate || this.rsvpData.leg1.flightDate
      pickupDate = pickupDate || moment().format('MM/DD/YYYY')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let quoteData = {
        date: pickupDate,
        leg: 'leg1',
        brandId: self.$store.state.brandId,
        pickup: {
          lat: self.rsvpData.leg1.pickup.lat,
          lng: self.rsvpData.leg1.pickup.lng
        },
        dropoff: {
          lat: self.rsvpData.leg1.dropoff.lat,
          lng: self.rsvpData.leg1.dropoff.lng
        },
        asap: false
      }

      self.quotationLoading = true
      self.quoteErrorMsg = ''
      quoteData = {
        brandId: self.$store.state.brandId,
        leg: 'leg1',
        pickupDate: pickupDate,
        pickup: {
          lat: self.rsvpData.leg1.pickup.lat,
          lng: self.rsvpData.leg1.pickup.lng
        },
        dropoff: {
          lat: self.rsvpData.leg1.dropoff.lat,
          lng: self.rsvpData.leg1.dropoff.lng
        },
        order: 'priority',
        asap: false
      }
      quoteData.pickup = self.rsvpData.leg1.pickup
      quoteData.dropoff = self.rsvpData.leg1.dropoff
      self.extraStop.leg1.forEach((stop, index) => {
        if (!quoteData.extraStops) {
          quoteData.extraStops = []
        }
        quoteData.extraStops.push({
          lat: stop.location.lat,
          lng: stop.location.lng
        })
      })

      if (self.charter.enabled) {
        let startDate = moment(self.charter.startDate, 'MM/DD/YYYY hh:mmA')
        let endDate = moment(self.charter.endDate, 'MM/DD/YYYY hh:mmA')
        let duration = moment.duration(endDate.diff(startDate))
        quoteData = {
          brandId: self.$store.state.brandId,
          pickupDate: startDate.format('YYYY-MM-DD'),
          etaInSec: duration.asSeconds(),
          pickup: self.charter.pickup,
          isCharter: true,
          leg: 'leg1'
        }
      }

      if (self.widgetTab === 'd2d') {
        self.$store.commit('other/setOtherData', {
          appLoader: true,
          appLoaderMsg: ''
        })
      }
      ApiQuote.getQuote2(self, quoteData, res => {
        self.quotationLoading = false
        if (!res.error) {
          if (
            (!res.services.length && !res.mtech && !res.lyft) ||
            (res.mtech && !res.mtech.services.length) ||
            (res.lyft && !res.lyft.length)
          ) {
            self.quoteErrorMsg = self.$t('searchForm.noAvailableService')
            return
          }
          if (res.mtech && self.extraStop.leg1.length) {
            self.quoteErrorMsg = self.$t('searchForm.serviceNA')
            return
          }
          if (!self.charter.enabled) {
            if (res.geofences.pickup.type === 'airport' ||
              res.geofences.dropoff.type === 'airport'
            ) {
              self.getAirlineList()
            }

            if (res.geofences.dropoff.type === 'airport') {
              self.$store.commit('reservation/setIsAirportPickup', {
                leg: 'leg2',
                value: true
              })
            }

            self.$store.commit('reservation/resetServiceEta')
          } else {
            if (res.airport && res.airport.id) {
              self.getAirlineList()
            }
          }

          let serviceExist = false
          for (let service in res.services) {
            let serviceData = res.services[service]
            if (parseInt(self.rsvpData.leg1.selectedService.substr(1)) === serviceData.serviceType.id && !serviceData.unavailableTime) {
              serviceExist = true
            }
          }
          if (!serviceExist) {
            self.$store.commit('reservation/setSelectedService', {
              leg: 'leg1',
              value: ''
            })
          }

          if (self.mtech.enabled && self.rsvpData.leg1.selectedService) {
            self.getQuoteMtechService()
          }

          // self.$root.$router.push('service')
          if (self.showOnLoad) {
            document.body.classList.add('widget-full')
          }

          self.$root.$router.push('service')
          window.location.href = '#/service'
        } else {
          if (self.widgetTab === 'd2d') {
            self.d2dQueue = ['getAirports', 'pickupNearestAirport', 'dropoffNearestAirport', 'getFlight']
            self.d2dProcess()
            return
          }
          self.quoteErrorMsg = res.error.message
          if (res.error.message === 'Services unavailable') {
            self.quoteErrorMsg = self.$t('searchForm.sorryService')
          }
        }
      })
    },
    cancel () {
      let loc = window.location.href
      let index = loc.indexOf('#')
      window.location.href = loc.substring(0, index) + '#'

      this.$root.$emit('close')
    },
    locationNewValue (value) {
      let self = this
      if (value.fromMap && !value.keyInput.trim()) return

      if (value.field === 'pickup') {
        self.pickupText = value.keyInput
        this.$emit('pickupChange')
        if (value.keyInput.trim() === '') {
          self.$store.commit('reservation/setPickup', {
            leg: value.leg,
            value: ''
          })
        } else {
          if (!value.blurStop) {
            this.validation.pickup = ''
            if (self.extraStop[value.leg].length) {
              if (this.$refs[`extraStop${self.extraStop.leg1[0].id}`][0].focus) {
                this.$refs[`extraStop${self.extraStop.leg1[0].id}`][0].focus()
              }
            } else if (this.$refs.dropoff) {
              this.$refs.dropoff.focus()
            }
          }
        }
      } else if (value.field === 'extraStop') {
        self.$store.commit('reservation/setExtraStopData', {
          leg: value.leg,
          id: value.id,
          fields: { text: value.keyInput }
        })
        if (value.keyInput.trim() === '') {
          self.$store.commit('reservation/setExtraStopLocationData', {
            leg: value.leg,
            id: value.id,
            value: ''
          })
        } else {
          if (!value.blurStop) {
            self.$store.commit('reservation/setExtraStopData', {
              leg: value.leg,
              id: value.id,
              fields: { error: '' }
            })
            let index = self.extraStop.leg1.findIndex(x => x.id === value.id)
            if (index === self.extraStop.leg1.length - 1) {
              if (this.$refs.dropoff.focus) {
                this.validation.extraStop = ''
                this.$refs.dropoff.focus()
              }
            } else if (index > -1) {
              if (this.$refs[`extraStop${self.extraStop.leg1[index + 1].id}`][0].focus) {
                this.$refs[`extraStop${self.extraStop.leg1[index + 1].id}`][0].focus()
              }
            }
          }
          let index = self.extraStop.leg1.findIndex(x => x.id === value.id)
          let indexLeg2 = self.extraStop.leg2.findIndex(x => x.id === value.id)
          if (index > -1 && indexLeg2 === -1) {
            self.$store.commit('reservation/prependExtraStop', {
              leg: 'leg2',
              value: self.extraStop.leg1[index]
            })
          }
        }
      } else if (value.field === 'charter') {
        self.charterLocation.pickupText = value.keyInput
        self.charterLocation.validation = ''
      } else {
        self.dropoffText = value.keyInput
        if (value.keyInput.trim() === '') {
          self.$store.commit('reservation/setDropoff', {
            leg: value.leg,
            value: ''
          })
        } else {
          this.validation.dropoff = ''
          if (self.pickupText !== '' && !value.blurStop && self.widgetTab !== 'd2d') {
            // self.validateGeo(null, 'leg1')
            self.triggerClickSubmit()
          }
        }
      }
    },
    buildServiceData (data) {
      let oneway = []
      let roundtrip = []
      for (let i = 0; i < data.maxPassengers; i++) {
        data.oneway[i].price = parseFloat(data.oneway[i].price)
        data.oneway[i].original = parseFloat(data.oneway[i].original)
        data.roundtrip[i].price = parseFloat(data.roundtrip[i].price)
        data.roundtrip[i].original = parseFloat(data.roundtrip[i].original)

        oneway.push(data.oneway[i])
        roundtrip.push(data.roundtrip[i])
      }

      return {
        id: data.id,
        code: data.code,
        brandedName: data.brandedName,
        maxLuggage: data.maxLuggage,
        maxPassengers: data.maxPassengers,
        curbside: data.curbside,
        meetAndGreet: data.meetAndGreet,
        pickupFee: data.pickupFee,
        prices: oneway,
        roundtrip: roundtrip,
        status: data.status,
        airportFee: data.airportFee
      }
    },
    getAirlineList () {
      let self = this

      let pickup = self.rsvpData.leg1.pickup
      let dropoff = self.rsvpData.leg1.dropoff
      if (typeof pickup.geofenceType === 'undefined' ||
        (pickup.geofenceType !== 'airport' && dropoff.geofenceType !== 'airport')
      ) { return }

      if (self.airlineLoading || self.rsvpData.airlineGID === pickup.geofenceId) { return }
      self.$store.commit('reservation/setAirlineLoading', true)

      let geofenceId = pickup.geofenceId
      if (pickup.geofenceType !== 'airport' && dropoff.geofenceType === 'airport') { geofenceId = dropoff.geofenceId }
      if (self.charter.enabled) {
        geofenceId = self.charter.airportGeoId
      }
      self.$sdk.get(self, '/geofences/' + geofenceId + '/airlines', {}, res => {
        self.$store.commit('reservation/setAirlineLoading', false)
        if (!res.error) {
          let airlines = []
          res.list.forEach(function (data) {
            airlines.push({
              code: data.code,
              name: data.name,
              label: '(' + data.code + ') ' + data.name
            })
          })
          self.$store.commit('reservation/setAirlineList', {
            id: geofenceId,
            list: airlines
          })
        }
      }, '/1.1')
    },
    goEditRsvp (event) {
      if (event) event.preventDefault()
      this.$root.$router.push('search-edit')
      window.location.href = '#/search-edit'
    },
    goTrackRsvp (event) {
      if (event) event.preventDefault()
      this.$root.$router.push('search-track')
      window.location.href = '#/search-track'
    },
    getAds () {
      let self = this
      self.$store.commit('ads/resetList')
      self.$store.commit('ads/setLoading', true)

      ApiAds.getAds(self, { brandId: self.$store.state.brandId }, (res) => {
        self.$store.commit('ads/setLoading', false)
        self.$store.commit('ads/setAdsCheck', true)
      })
    },
    getAirports () {
      let self = this
      if (self.$store.state.airports.list.length > 0 || self.airportListLoading) { return }

      self.airportListLoading = true
      self.$sdk.get(self, '/popular', {}, res => {
        if (res.error) { return }

        let airports = res.airports
        if (['op', 'gs', 's2l'].indexOf(self.$store.state.brandCode) > -1) {
          airports = []
          res.airports.forEach(x => {
            if (['LAX', 'LGB', 'BUR', 'SNA', 'ONT', 'SAN'].indexOf(x.airportCode) > -1) {
              airports.push(x)
            }
          })
        }
        self.$store.commit('staticLocations/setAirports', self.buildStaticLocation('airports', airports))
        self.$store.commit('staticLocations/setHotels', self.buildStaticLocation('hotels', res.hotels))
        self.$store.commit('staticLocations/setPorts', self.buildStaticLocation('ports', res.ports))
        self.$store.commit('staticLocations/setUniversities', self.buildStaticLocation('universities', res.universities))
      })
    },
    buildStaticLocation (type, data) {
      if (!data.length) { return [] }

      let list = []
      for (let i = 0; i < data.length; i++) {
        let item = data[i]
        let add1 = item.address2 === null ? item.address1 : item.address2
        let add2 = item.address2 === null ? '' : item.address1

        let title = add2 + ' ' + add1 + ', ' + item.city + ', ' + item.state + ' ' + item.zip
        let locData = {
          address1: item.address1,
          address2: item.address2,
          city: item.city,
          country: item.country,
          state: item.state,
          title: title,
          zip: item.zipCode,
          lat: item.lat,
          lng: item.lng,
          shortName: this.removeNull(item.shortName),
          longName: item.longName
        }
        list.push(locData)

        if (type === 'airports' && this.initAirportPickup && item.airportCode === this.initAirportPickup) {
          this.$store.commit('reservation/setPickup', {
            leg: 'leg1',
            value: locData
          })
          // this.$store.commit('reservation/setInitAirportPickup', '')
          this.pickup = locData.longName
        }
      }
      list.sort((a, b) => {
        if (a.shortName === b.shortName) return 0
        if (a.shortName === 'Los Angeles, CA (LAX)') return -1
        if (b.shortName === 'Los Angeles, CA (LAX)') return 1
        if (a.shortName < b.shortName) return -1
        if (a.shortName > b.shortName) return 1
      })
      return list
    },
    checkShowOnLoad () {
      if (!this._brandId) { return }
      let brandData = Object.values(CONFIG.Brands).find((v) => {
        return parseInt(this._brandId, 10) === parseInt(v.id, 10)
      }) || false
      let firstPage = ['Search', 'SearchEdit', 'SearchTrack', 'Booking1', 'Booking2', 'Track']
      document.body.classList.remove('widget-full')
      if (brandData) {
        this.showOnLoad = brandData.showOnLoad && firstPage.indexOf(this.route) > -1 ? 'show-on-load' : ''
      }
      if (!this.showOnLoad) {
        this.$refs.pickup.focus()
      }
    },
    // logout () {
    //   let self = this
    //   self.$store.commit('user/setIsCorporate', false)
    //   this.$root.user = null
    //   cookie.delete('userToken')
    //   self.$store.commit('user/reset')
    //   self.$store.commit('disablePreviousSteps', 2)
    //   self.$store.commit('disablePreviousSteps', 3)
    //   self.$store.commit('enablePreviousSteps', 1)

    //   if (window.fcWidget) {
    //     window.fcWidget.user.clear().then(function () {}, function () {})
    //   }
    //   ApiPickupType.update(self, { action: 'logout' }, function (data) { })
    // },
    getVariable (url) {
      let query = window.location.search.substring(1);
      let vars = query.split('&')
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (pair[0] === url) {
          return pair[1]
        }
      }
      return false
    },
    focusOnNewExtra () {
      if (this.extraStop.leg1.length) {
        if (this.$refs[`extraStop${this.extraStop.leg1[this.extraStop.leg1.length - 1].id}`][0].focus) {
          this.$refs[`extraStop${this.extraStop.leg1[this.extraStop.leg1.length - 1].id}`][0].focus()
        }
      }
    },
    setTab (x) {
      if (this.quotationLoading) { return }
      this.widgetTab = x
      this.$store.commit('reservation/setCharterData', {enabled: x === 'charter'})
      this.$store.commit('reservation/setD2DData', {enabled: x === 'd2d'})
    },
    openPicker (x) {
      this.$store.commit('serviceSelection/showDateTimePicker')
      this.$store.commit('reservation/setCharterData', {datePicker: x})
      this.$forceUpdate()
    },
    getQuoteMtechService () {
      let self = this
      let rsvpData = this.$store.state.reservation.leg1

      let pickupDate = rsvpData.flightDate || rsvpData.pickupDate
      pickupDate = pickupDate || moment().format('MM/DD/YYYY hh:mmA')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY hh:mmA')
      let quoteData = {
        asap: false,
        brandId: self.$store.state.brandId,
        leg: 'leg1',
        pickupDate: pickupDate.format('YYYY-MM-DD'),
        pickupTime: pickupDate.format('HH:mm:ss'),
        pickup: rsvpData.pickup,
        dropoff: rsvpData.dropoff,
        order: 'priority',
        passengers: rsvpData.passenger,
        mtechServiceType: rsvpData.selectedService
      }
      quoteData.pickup.text = quoteData.pickup.title
      quoteData.dropoff.text = quoteData.dropoff.title
      if (rsvpData.flightDate) {
        quoteData.pickupTimestamp = moment.tz(rsvpData.flightDate, 'MM/DD/YYYY hh:mmA', rsvpData.timezone).format('X')
      } else {
        quoteData.pickupTimestamp = moment.tz(`${quoteData.pickupDate} ${quoteData.pickupTime}`, 'YYYY-MM-DD HH:mm', rsvpData.timezone).format('X')
      }

      self.$store.commit('reservation/setServiceLoading', true)
      let timeNow = moment()
      self.$sdk.post(self, '/quotation', quoteData, res => {
        self.sendQuoteTime(timeNow, moment(), res.quoteId, quoteData)
        self.$store.commit('reservation/setServiceLoading', false)
        if (!res.error) {
          self.$store.commit('reservation/setQuoteId', res.quoteId)
          if (res.mtech.services.length) {
            let mtech = res.mtech
            let mtechStore = self.$store.state.reservation.mtech
            let service = res.mtech.services[0]
            let price = service.price

            let hasDiscount = false
            let discountVal = 0
            let totalBeforeDc = 0
            let baseFare = price.amount
            service.price.breakdown.forEach(x => {
              if (x.description === 'Base rate') {
                baseFare = x.amount
              }
              if (x.description === 'Discount') {
                hasDiscount = true
                discountVal = x.amount
              }
              if (x.amount > 0) {
                totalBeforeDc += x.amount
              }
            })

            let addMarkup = 0
            if (mtech.markup.value) {
              addMarkup = mtechStore.markup.value
              if (mtech.markup.type === '%') {
                addMarkup = baseFare * (mtech.markup.value / 100)
              }
              addMarkup = parseFloat(addMarkup.toFixed(2))
            }

            self.$store.commit('reservation/setMtechNewPricing', {
              code: rsvpData.selectedService,
              val: {
                baseFare: baseFare,
                amount: price.amount,
                addMarkup: addMarkup,
                breakdown: price.breakdown,
                hasDiscount: hasDiscount,
                discountVal: Math.abs(discountVal),
                totalBeforeDc: totalBeforeDc
              }
            })
          }
          self.$nextTick().then(() => {
            self.$forceUpdate()
          })
        }
      }, '2.0')
    },
    triggerClickSubmit () {
      if (this.$refs.quoteBtn) this.$refs.quoteBtn.click()
    },
    removeNull (x) {
      return x.replace('null', '')
    },
    mapNewValue (data) {
      if (data.field === 'charter') {
        this.charterLocation.pickup = data.keyInput
      }
      if (['pickup', 'dropoff'].indexOf(data.field) > -1) {
        this[data.field] = data.keyInput
        this.$emit(`${data.field}Change`)
      }
      this.locationNewValue(data)
    },
    sendQuoteTime (start, end, quoteId, param) {
      let self = this
      let store = self.$store.state
      let duration = end.diff(start, 'milliseconds') / 1000
      self.$sdk.opt('/quotation/time', {
        token: store.user.token,
        brandId: store.brandId,
        quotationId: quoteId,
        responseTime: duration,
        deviceType: 'ww',
        data: JSON.stringify(param)
      }, res => {
        if (res.error) console.log('ERROR quotation time')
      })
    },
    openDeparturePicker () {
      this.$store.commit('reservation/setD2dDeparture', {show: true})
    },
    openTravellersModal () {
      this.$store.commit('booking/setTravellersData', {show: true})
    },
    d2dProcess () {
      let self = this
      if (!self.d2dQueue.length) return
      // pickupNearestAirport', 'dropoffNearestAirport', 'getFlight
      if (self.d2dQueue[0] === 'getAirports') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Getting airport data...'})
        self.getAirportList()
      }
      if (self.d2dQueue[0] === 'pickupNearestAirport') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Searching for nearby Airport...'})
        setTimeout(function () {
          self.checkNearestAirport('pickup')
        }, 1000)
      }
      if (self.d2dQueue[0] === 'dropoffNearestAirport') {
        self.$store.commit('other/setOtherData', {appLoaderMsg: 'Searching for nearby Airport...'})
        self.checkNearestAirport('dropoff')
      }
      if (self.d2dQueue[0] === 'getFlight') {
        // self.$store.commit('other/setOtherData', {appLoaderMsg: 'Searching Flights...'})
        self.$store.commit('other/setOtherData', {
          appLoaderMsg: 'Don’t close now—your perfect deal is loading! This only takes up to a minute.',
          useLoadingMsg: true
        })
        self.getFlightQuote()
      }
    },
    getAirportList () {
      let self = this
      if (self.d2d.airports.length) {
        self.d2dQueue.shift()
        self.d2dProcess()
        return
      }

      self.$sdk.get(self, '/airport', {}, r => {
        let airports = []
        if (r.list) {
          r.list.forEach(data => {
            airports.push({
              name: data.name,
              code: data.code,
              address1: data.addressLine1,
              address2: data.addressLine2,
              city: data.city,
              state: data.state,
              zip: data.zipCode,
              country: data.country,
              lat: data.lat,
              lng: data.lng
            })
          })
        }
        self.$store.commit('reservation/setD2DData', {airports: airports})
        setTimeout(function () {
          self.d2dQueue.shift()
          self.d2dProcess()
        }, 500)
      }, '2.0')
    },
    checkNearestAirportViaAPI (type) {
      let self = this
      let apkey = CONFIG.hereApi.key
      let lat = self.rsvpData.leg1[type].lat
      let lng = self.rsvpData.leg1[type].lng
      request.get({
        url: `https://places.ls.hereapi.com/places/v1/discover/here?apiKey=${apkey}&at=${lat},${lng}&pretty&cat=airport`,
        json: true
      }, function (err, res, body) { // eslint-disable-line handle-callback-err
        if (body.results && body.results.items.length) {
          let data = {}
          data[`${type}Airport`] = body.results.items[0]
          self.$store.commit('reservation/setD2DData', data)
          self.d2dQueue.shift()
          self.d2dProcess()
        } else {
          // show error: no airport available
        }
      })
    },
    checkNearestAirport (type) {
      let self = this
      let loc = self.rsvpData.leg1[type]
      let coord1 = {
        lat: loc.lat,
        lng: loc.lng
      }
      let nearest = {
        airport: {},
        distance: ''
      }
      let tmpList = []
      self.d2d.airports.forEach((x, i) => {
        let currentDistance = self.getDistance(coord1, {lat: x.lat, lng: x.lng})
        if (!nearest.distance) {
          nearest.airport = self.d2d.airports[i]
          nearest.distance = currentDistance
        } else if (currentDistance < nearest.distance) {
          nearest.airport = self.d2d.airports[i]
          nearest.distance = currentDistance
        }
        if (currentDistance <= self.d2d.settings.nearByAirportMilesLimit) {
          tmpList.push({
            airport: self.d2d.airports[i],
            distance: currentDistance
          })
        }
      })
      tmpList.sort((a, b) => {
        return a.distance - b.distance
      })
      self.$store.commit('reservation/setD2DNearyByAirports', {
        field: type,
        val: tmpList
        // val: tmpList.splice(0, 5)
      })

      let data = {}
      data[`${type}Airport`] = nearest.airport
      self.$store.commit('reservation/setD2DData', data)

      self.d2dQueue.shift()
      self.d2dProcess()
    },
    getDistance (coord1, coord2) {
      let toRad = value => value * Math.PI / 180
      let R = 6371
      let latD = toRad(coord2.lat - coord1.lat)
      let longD = toRad(coord2.lng - coord1.lng)
      let a = Math.sin(latD / 2) * Math.sin(latD / 2) +
        Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) *
        Math.sin(longD / 2) * Math.sin(longD / 2)
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      let distance = R * c
      return distance / 1.609344
    },
    getFlightQuote () {
      let self = this
      if (self.d2dFlightLoading) return
      let params = {
        AdultCount: self.d2d.travellers.adult,
        ChildCount: self.d2d.travellers.children,
        InfantCount: self.d2d.travellers.infants,
        JourneyType: 'OneWay',
        PreferredAirlines: [''],
        CabinClass: 'Economy',
        Segments: [{
          Origin: self.d2d.pickupAirport.code,
          Destination: self.d2d.dropoffAirport.code,
          DepartureDate: moment(self.d2d.departure.date, 'MM/DD/YYYY').format('YYYY-MM-DD') + 'T00:00:00'
        }]
      }
      if (self.d2d.departure.isReturning) {
        params.JourneyType = 'Return'
        params.Segments[0].ReturnDate = moment(self.d2d.departure.return, 'MM/DD/YYYY').format('YYYY-MM-DD') + 'T00:00:00'
      }
      self.d2dFlightLoading = true
      self.$store.commit('reservation/setD2dAirlinesUnique', {'Economy': []})
      self.$sdk.post2(`${CONFIG.d2dAPI}/flight`, params, r => {
        self.d2dFlightLoading = false
        self.quotationLoading = false
        // if (r === null || !Object.keys(r).length) {
        //   self.$store.commit('global/setAlertData', {show: true, message: 'Our services is not available.'})
        //   self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        //   return
        // }
        try {
          if (!Object.keys(r).length) {
            self.$store.commit('global/setAlertData', {show: true, message: 'Our services is not available.'})
            return
          }
          self.$store.commit('reservation/setD2dAirlines', {
            selected: '',
            Economy: [],
            Business: [],
            First: [],
            filtered: {
              Economy: [],
              Business: [],
              First: []
            }
          })
          if (r.FlightDataList && r.FlightDataList.JourneyList && r.FlightDataList.JourneyList[0]) {
            self.$store.commit('reservation/setD2dAirlines', {economy: [], list: []})
            let airlinesUniqe = []
            // let airlinesCount = {}
            let haveData = false
            r.FlightDataList.JourneyList[0].forEach(data => {
              let price = data.Price
              let flightInfo = data.FlightDetails.Details[0]
              let flight = []
              let layover = 0
              let layoverReturn = 0
              let lastArriveTime = ''
              let lastArriveTimeReturn = ''
              flightInfo.forEach((f, i) => {
                haveData = true
                flight.push({
                  origin: f.Origin,
                  destination: f.Destination,
                  duration: parseInt(f.Duration),
                  airline: {
                    code: f.OperatorCode,
                    name: f.OperatorName
                  },
                  flightNo: f.FlightNumber,
                  logo: f.OperatorLogo || 'https://prod-opoli-web.s3.us-west-2.amazonaws.com/wordpress-assets/op/home/default-logo.png'
                })
                if (lastArriveTime) {
                  layover += moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').diff(lastArriveTime, 'minutes')
                }
                lastArriveTime = moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm')
              })
              let returnFlight = []
              if (self.d2d.departure.isReturning && data.FlightDetails.Details.length > 1) {
                data.FlightDetails.Details[1].forEach(f => {
                  haveData = true
                  returnFlight.push({
                    origin: f.Origin,
                    destination: f.Destination,
                    duration: parseInt(f.Duration),
                    airline: {
                      code: f.OperatorCode,
                      name: f.OperatorName
                    },
                    flightNo: f.FlightNumber,
                    logo: f.ReturnOperatorLogo || 'https://prod-opoli-web.s3.us-west-2.amazonaws.com/wordpress-assets/op/home/default-logo.png'
                  })
                  if (lastArriveTimeReturn) {
                    layoverReturn += moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').diff(lastArriveTimeReturn, 'minutes')
                  }
                  lastArriveTimeReturn = moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm')
                })
              }
              let TotalDisplayFare = price.PriceBreakup.BasicFare
              if (price.PriceBreakup.Tax) TotalDisplayFare += price.PriceBreakup.Tax
              let totalWithMarkUp = TotalDisplayFare + (TotalDisplayFare * this.d2d.settings.markUpPercent)
              self.$store.commit('reservation/addD2DAirlineFlights', {
                field: 'Economy',
                value: {
                  payment: {
                    currency: price.Currency,
                    total: parseFloat(TotalDisplayFare.toFixed(2)),
                    totalWithMarkUp: parseFloat(totalWithMarkUp.toFixed(2)),
                    breakdown: price.PassengerBreakup.ADT
                  },
                  isRefundable: data.Attr ? (data.Attr.IsRefundable || false) : false,
                  airlineRemark: data.Attr ? (data.Attr.AirlineRemark || '') : '',
                  fareType: data.Attr ? (data.Attr.FareType || '') : '',
                  flight: flight,
                  returnFlight: returnFlight,
                  flightName: flightInfo[0].OperatorName.toLowerCase(),
                  token: data.ResultToken,
                  available: true,
                  layover: {
                    leg1: layover,
                    leg2: layoverReturn
                  }
                }
              })

              // if (!airlinesCount[flightInfo[0].OperatorName.toLowerCase()]) airlinesCount[flightInfo[0].OperatorName.toLowerCase()] = 0
              // airlinesCount[flightInfo[0].OperatorName.toLowerCase()]++

              if (airlinesUniqe.indexOf(flightInfo[0].OperatorName.toLowerCase()) === -1) {
                if (flightInfo[0].OperatorName) {
                  airlinesUniqe.push(flightInfo[0].OperatorName.toLowerCase())
                }
              }
            })
            if (haveData) {
              self.$store.commit('reservation/setD2dAirlines', {selectedCabin: 'Economy'})
            }
            airlinesUniqe.sort()
            // self.$store.commit('reservation/setD2dAirlines', {list: airlinesUniqe})
            // self.$store.commit('reservation/setD2dFilterCountAirlines', {'Economy': airlinesCount})
            self.$store.commit('reservation/setD2dAirlinesUnique', {'Economy': airlinesUniqe})
            // self.$store.commit('reservation/setD2DData', {fetch: ['Business', 'First']})
            if (self.lastPickup !== self._pickup || self.lastDropoff !== self._dropoff) {
              self.$store.commit('reservation/setD2DData', {
                includedLandTranspo: self.d2d.departure.isReturning ? [0, 1, 2, 3] : [0, 1]
              })
            }
            self.$store.commit('other/setOtherData', {
              appLoader: false,
              appLoaderMsg: ''
            })
            if (self.showOnLoad) {
              document.body.classList.add('widget-full', 'd2d-mode')
            }
            self.setupPax()
            localStorage.removeItem('lastPickupLoc')
            localStorage.removeItem('lastDropoffLoc')
            localStorage.setItem('lastPickupLoc', JSON.stringify(self.rsvpData.leg1.pickup))
            localStorage.setItem('lastDropoffLoc', JSON.stringify(self.rsvpData.leg1.dropoff))
            self.$router.push('d2dservice')
          }
        } catch (error) {
          self.d2dFlightLoading = false
          self.quotationLoading = false
          self.$store.commit('other/setOtherData', {
            appLoader: false,
            appLoaderMsg: ''
          })
          self.$store.commit('global/setAlertData', {show: true, message: 'Something went wrong. Please adjust your search and try again.'})
        }
      })
    },
    setupPax () {
      let paxForm = { adult: [], children: [], infants: [] }
      let paxFields = {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        mobile: '',
        email: '',
        bday: '',
        birthDay: '',
        birthMonth: '',
        birthYear: '',
        passport: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        countryCode: ''
      }
      let defaultAdded = false
      for (let x = 0; x < this.d2d.travellers.adult; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        if (this.user.token && x === 0 && !defaultAdded) {
          tmpObj.firstName0 = this.user.firstName
          tmpObj.lastName0 = this.user.lastName
          tmpObj.email0 = this.user.email
          tmpObj.mobile0 = this.user.phone.number
          tmpObj.countryCode0 = this.user.phone.code
          defaultAdded = true
        }
        paxForm.adult.push(tmpObj)
      }
      for (let x = 0; x < this.d2d.travellers.children; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        // if (this.user.token && x === 0 && !defaultAdded) {
        //   tmpObj.firstName0 = this.user.firstName
        //   tmpObj.lastName0 = this.user.lastName
        //   tmpObj.email0 = this.user.email
        //   tmpObj.mobile0 = this.user.phone.number
        //   tmpObj.countryCode0 = this.user.phone.code
        //   defaultAdded = true
        // }
        paxForm.children.push(tmpObj)
      }
      for (let x = 0; x < this.d2d.travellers.infants; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        // if (this.user.token && x === 0 && !defaultAdded) {
        //   tmpObj.firstName0 = this.user.firstName
        //   tmpObj.lastName0 = this.user.lastName
        //   tmpObj.email0 = this.user.email
        //   tmpObj.mobile0 = this.user.phone.number
        //   tmpObj.countryCode0 = this.user.phone.code
        //   defaultAdded = true
        // }
        paxForm.infants.push(tmpObj)
      }
      this.$store.commit('reservation/clearTravellerInfo')
      this.$store.commit('reservation/addTravellerInfo', paxForm)
    },
    showGlobalLogin () {
      this.$store.commit('global/setAuthData', {show: true})

      if (window.gtag) { // eslint-disable-line
        gtag('event', 'Flight Booking - Login') // eslint-disable-line
      }
    },
    showGlobalSignup () {
      this.$store.commit('global/setAuthData', {showSignup: true})

      if (window.gtag) { // eslint-disable-line
        gtag('event', 'Flight Booking - Signup') // eslint-disable-line
      }
    },
    logout () {
      let self = this
      // self.showLoggedInOptions = false
      self.session.destroy()
      self.$store.commit('user/reset')
      cookie.delete('userToken')
      self.$store.commit('cards/setCardData', {
        lastUserID: '',
        list: []
      })
      self.$store.commit('setCredits', 0)
      self.$store.commit('global/setLoaderData', {show: true})
      // self.authRender = false
      setTimeout(function () {
        // self.authRender = true
        self.$store.commit('global/setLoaderData', {show: false})
      }, 500)
    },
    getFlights () {
      let self = this
      // self.showLoggedInOptions = false
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/get`, {
        token: self.user.token,
        order: 'pickupTime',
        status: 'upcoming',
        desc: true,
        pageNum: 1,
        pageSize: 50,
        raw: true
      }, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        if (!r.list.length) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'No booked flights as of yet.'
          })
          self.$store.commit('flights/setFlightData', {list: []})
          setTimeout(function () {
            self.$store.commit('global/setLoaderData', {show: false})
            self.$store.commit('flights/setFlightTrackData', {enable: false})
            document.body.classList.add('widget-full', 'd2d-mode')
            self.$router.push('my-flights')
          }, 250)
          return
        }
        let flights = []
        r.list.forEach(f => {
          if (f.roundTripId) {
            let index = flights.findIndex(x => x.id === f.roundTripId)
            if (index > -1) {
              flights[index].roundTripData = self.buildFlightListData(f)
              return
            }
          }
          flights.push(self.buildFlightListData(f))
        })
        // flights.sort((a, b) => {
        //   return a.dateSort - b.dateSort
        // })
        self.$store.commit('flights/setFlightData', {list: flights})
        setTimeout(function () {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('flights/setFlightTrackData', {enable: false})
          document.body.classList.add('widget-full', 'd2d-mode')
          self.$router.push('my-flights')
        }, 250)
      })
    },
    buildFlightListData (f) {
      let logo = ''
      if (f.commitData && f.commitData.CommitBooking && f.commitData.CommitBooking.BookingDetails.JourneyList.FlightDetails.Details.length) {
        logo = f.commitData.CommitBooking.BookingDetails.JourneyList.FlightDetails.Details[0][0].DisplayOperatorCode
        let tmp = airlines.find(x => x.code === logo)
        if (tmp) logo = tmp.logo
      }
      let isRefundable = false
      if (f.priceData) isRefundable = f.priceData.UpdateFareQuote.FareQuoteDetails.JourneyList.Attr.IsRefundable
      return {
        id: f.id,
        bookingId: f.bookingId,
        pnr: f.pnr,
        origin: {
          code: f.originAirportCode,
          name: f.originAirportName,
          date: moment(f.originDateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
        },
        destination: {
          code: f.destAirportCode,
          name: f.destAirportName,
          date: moment(f.destDateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
        },
        status: f.status,
        // isRoundTrip: f.roundTripId ? (f.id < f.roundTripId ? 'round-trip' : '') : '',
        dateSort: parseInt(moment(f.originDateTime, 'YYYY-MM-DD HH:mm').format('x')),
        logo: logo,
        isRefundable: isRefundable
      }
    },
    trackRevalidate (field) {
      if (this.track[field]) this.track.validation[field] = ''
    },
    trackRsvp () {
      let self = this
      self.track.validation = {
        pnr: '',
        firstName: '',
        lastName: ''
      }
      let fields = ['pnr', 'firstName', 'lastName']
      let hasError = false
      fields.forEach(f => {
        if (!self.track[f]) {
          hasError = true
          self.track.validation[f] = this.$t('common.fieldEmpty')
        }
      })
      if (hasError) return
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/guest`, {
        pnr: self.track.pnr,
        firstName: self.track.firstName,
        lastName: self.track.lastName,
        raw: true
      }, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        if (!r.list.length) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Unable to find your reservation. Please ensure you entered the correct Airline PNR and name exactly as it appears on your booking confirmation.'
          })
          return
        }
        self.buildFlightData(r)
      })
    },
    buildFlightData (r) {
      let self = this
      let data = r.list[0]
      let tmp = {
        id: data.id,
        bookingId: data.bookingId,
        booked: moment(data.createdUTC, 'X').format('MM/DD/YYYY hh:mmA'),
        pnr: data.pnr,
        airFareTotal: data.fareFlightTotal,
        roundtripId: data.roundTripId,
        credits: data.credits || 0,
        flights: {
          oneway: [],
          return: []
        },
        pax: [],
        status: data.status,
        isRefundable: data.isRefundable
      }
      let flightDetails = data.priceData.UpdateFareQuote.FareQuoteDetails.JourneyList.FlightDetails.Details
      flightDetails[0].forEach(f => {
        tmp.flights.oneway.push({
          flightName: f.OperatorName,
          flightCode: f.OperatorCode,
          flightNo: f.FlightNumber,
          duration: f.Duration,
          origin: {
            code: f.Origin.AirportCode,
            name: f.Origin.AirportName,
            date: moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
          },
          destination: {
            code: f.Destination.AirportCode,
            name: f.Destination.AirportName,
            date: moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
          }
        })
      })
      if (data.roundTripId && flightDetails[1]) {
        flightDetails[1].forEach(f => {
          tmp.flights.return.push({
            flightName: f.OperatorName,
            flightCode: f.OperatorCode,
            flightNo: f.FlightNumber,
            duration: f.Duration,
            origin: {
              code: f.Origin.AirportCode,
              name: f.Origin.AirportName,
              date: moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
            },
            destination: {
              code: f.Destination.AirportCode,
              name: f.Destination.AirportName,
              date: moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
            }
          })
        })
      }
      data.commitData.CommitBooking.BookingDetails.PassengerDetails.forEach(p => {
        tmp.pax.push({
          firstName: p.FirstName,
          lastName: p.LastName,
          ticketId: p.TicketId,
          ticketNo: p.TicketNumber
        })
      })
      let currency = {code: 'USD'}
      if (data.currency) {
        currency = {
          code: data.currency.currency,
          flight: data.currency.flight,
          credits: data.currency.credits
        }
      }
      let flightData = {
        selected: tmp,
        currency: currency
      }
      self.$store.commit('flights/setFlightData', flightData)
      let rsvps = []
      let isLeg1 = true
      if (data.roundTripId) isLeg1 = data.id < data.roundTripId
      if (data.rsvpId1) {
        rsvps.push({id: data.rsvpId1, target: isLeg1 ? 'rsvp1' : 'rsvp3'})
      }
      if (data.rsvpId2) {
        rsvps.push({id: data.rsvpId2, target: isLeg1 ? 'rsvp2' : 'rsvp4'})
      }
      if (data.roundTripId && r.list[1]) {
        let data2 = r.list[1]
        isLeg1 = data2.id < data2.roundTripId
        if (data2.rsvpId1) {
          rsvps.push({id: data2.rsvpId1, target: isLeg1 ? 'rsvp1' : 'rsvp3'})
        }
        if (data2.rsvpId2) {
          rsvps.push({id: data2.rsvpId2, target: isLeg1 ? 'rsvp2' : 'rsvp4'})
        }
      }
      if (rsvps.length) self.getRsvpData(rsvps)
    },
    getRsvpData (rsvps) {
      let self = this
      if (!rsvps.length) {
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('flights/setFlightTrackData', {
          enable: true,
          pnr: self.track.pnr,
          firstName: self.track.firstName,
          lastName: self.track.lastName
        })
        document.body.classList.add('widget-full', 'd2d-mode')
        self.$router.push('my-flights')
        return
      }
      let firstName = self.track.firstName
      let lastName = self.track.lastName
      self.$sdk.get(self, `/reservations/${rsvps[0].id}/${firstName}/${lastName}`, {}, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        let tmp = {}
        let total = parseFloat(r.breakdown.total || 0) + (r.gasFee || 0)
        tmp[rsvps[0].target] = {
          id: r.ID,
          service: r.serviceType.label,
          pickup: r.pickupLocation,
          dropoff: r.dropoffLocation,
          pickupDate: moment(r.pickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(r.pickupTimezone).format('MM/DD/YYYY hh:mmA'),
          payment: total.toFixed(2)
        }
        self.$store.commit('flights/setFlightData', tmp)
        rsvps.shift()
        self.getRsvpData(rsvps)
      })
    },
    reverseLoc () {
      let pickup = Object.assign({}, this.rsvpData.leg1.pickup)
      let dropoff = Object.assign({}, this.rsvpData.leg1.dropoff)

      this.dropoffText = pickup.title
      this.pickupText = dropoff.title
      this.dropoff = pickup.title
      this.pickup = dropoff.title
      this.$store.commit('reservation/setPickup', {
        leg: 'leg1',
        value: dropoff
      })
      this.$store.commit('reservation/setDropoff', {
        leg: 'leg1',
        value: pickup
      })
      this.$store.commit('airports/sortList', { lat: dropoff.lat, lng: dropoff.lng })
      this.$emit('pickupChange')
    },
    updateCurrencyValue () {
      if (!Object.keys(this.currencyStore.list).length) return
      this.$store.commit('other/setCurrencyData', {
        symbol: currencySymbol[this.currency],
        value: this.currencyStore.list[this.currency]
      })
      localStorage.setItem('widgetCurrency', JSON.stringify({
        code: this.currencyStore.code,
        symbol: this.currencyStore.symbol,
        value: this.currencyStore.value,
        list: this.currencyStore.list
      }))
    },
    reconvertCurrency (x, code) {
      let currRate = self.currencyStore.list[code]
      x = parseFloat(x.toFixed(2))
      x = parseFloat((x / currRate).toFixed(2))
      return x
    },
    tabHover (x) {
      if (this.tooltip.delay) clearTimeout(this.tooltip.delay)
      this.tooltip.active = x
      let self = this
      self.tooltip.delay = setTimeout(function () {
        self.tooltip.active = ''
      }, 30000)
    },
    tabHoverOut () {
      // let self = this
      // self.tooltip.delay = setTimeout(function () {
      //   self.tooltip.active = ''
      // }, 3000)
    },
    continueBooking () {
      let source = this.user.firstVisit.source
      if (source) {
        if (this.$refs[`${source}Widget`].continueBooking()) this.$refs[`${source}Widget`].continueBooking()
      }
    },
    showUserInfo () {
      this.$store.commit('global/setUserInfoData', {show: true})
    },
    redirectNEW (target) {
      // if (['Booking1', 'Booking2', 'Track'].indexOf(this.$route.name) > -1) {
      //   let page = 'flight-booking'
      //   let widgetPage = 'booking1'
      //   if (target === 'ground') {
      //     page = 'book-a-ride'
      //     widgetPage = 'booking2'
      //   }
      //   if (target === 'track') {
      //     page = 'track-reservations'
      //     widgetPage = 'track'
      //   }

      //   let pathUrl = window.location.pathname.split('/')
      //   let tmpPath = []
      //   pathUrl.forEach(x => {
      //     if (x && ['flight-booking', 'book-a-ride', 'track-reservations'].indexOf(x) === -1) {
      //       tmpPath.push(x)
      //     }
      //   })
      //   if (tmpPath.length) page = `${tmpPath.join('/')}/${page}`

      //   let url = `${window.location.origin}/${page}/#/${widgetPage}`
      //   window.location.href = url
      // } else {
      //   this.widgetTab = target
      // }
      this.widgetTab = target
    },
    tripTypeUpdate () {
      if (window.gtag) { // eslint-disable-line
        gtag( // eslint-disable-line
          'event',
          this.d2d.departure.isReturning ? 'Flight Booking - Round Trip' : 'Flight Booking - Single Trip'
        )
      }
    },
    getFlightNearestAirport (coords) {
      // console.log('aaa', coords)
    },
    forceGround () {
      if (this.$refs.groundWidget) {
        this.$refs.groundWidget.forceGround()
      }
    },
    newDate () {
      if (this.widgetTab === 'd2d' && this.locations.pickup.title && this.locations.dropoff.title) {
        // if (this.$refs.d2dWidget) this.$refs.d2dWidget.submit()
        this.openTravellersModal()
      }
      if (this.widgetTab === 'flight' && this.locations.flight.pickup.title && this.locations.flight.dropoff.title) {
        // if (this.$refs.flightWidget) this.$refs.flightWidget.submit()
        this.openTravellersModal()
      }
      // if (this.pickupText && this.dropoffText) {
      //   this.highlight.active = 'search'
      // }

      if (window.gtag) { // eslint-disable-line
        gtag( // eslint-disable-line
          'event',
          'Flight Booking - Date',
          {value: this.departureDate}
        )
      }
    }
  },
  watch: {
    _pickup: function (value) {
      this.pickupText = value
      this.$emit('pickupChange')
    },
    _dropoff: function (value) {
      this.dropoffText = value
      this.$emit('dropoffChange')
    },
    _brandId: function (value) {
      this.getAds()
      this.checkShowOnLoad()
    },
    _homePageTracked: function (value) { this.getAds() },
    // _charterPickup: function (value) {
    //   this.charterLocation.pickupText = value
    //   this.$emit('charterPickupChange')
    //   this.highlight = 'startDate'
    // },
    // 'charter.startDate': function (val) {
    //   if (val) {
    //     this.highlight = 'endDate'
    //     this.charterValidation.startDate = ''
    //     this.$store.commit('reservation/setCharterData', {endDate: ''})
    //   }
    // },
    // 'charter.endDate': function (val) {
    //   if (val) {
    //     this.charterValidation.endDate = ''
    //     if (this.charterLocation.pickupText && this.charter.startDate) {
    //       this.triggerClickSubmit()
    //     }
    //   }
    // },
    'd2d.departure.date': function (val) {
      this.d2dValidation.date = ''
    },
    widgetTab (val) {
      this.$store.commit('other/setOtherData', {widgetTab: val})
    },
    'other.widgetTab': function (val) {
      if (val) this.widgetTab = val
    }
  },
  created () {
    let self = this
    self.$store.commit('setCurrentIndex', -1)

    if (self.$store.state.reservation.sharedAllowedTime.start === '') {
      request.get({
        url: CONFIG.Gateway.url + '/appsettings',
        json: true
      }, function (err, res, body) { // eslint-disable-line handle-callback-err
        self.$store.commit('setTravelInsuranceLabel', body.TravelInsuranceLabel)
        self.$store.commit('reservation/setDriverResponseTime', parseInt(body.DriverResponseTime))
        self.$store.commit('reservation/setWebTimeBuffer', parseInt(body.WebTimeBuffer))
        self.$store.commit('reservation/setSharedAllowedTime', {
          start: body.AirportStart,
          end: body.AirportEnd
        })
        self.$store.commit('reservation/setOptinAllowedTime', {
          start: body.OptinAirportStart,
          end: body.OptinAirportEnd
        })
        self.$store.commit('user/setResendCooldown', parseInt(body.SMSVerificationTimer))
        self.$store.commit('reservation/setCharterData', {
          MilitaryTimeWidget: body.MilitaryTimeWidget,
          globalEnabled: body.CharterEnabled === 1,
          maxDuration: body.CharterMaxDuration
        })
        self.$store.commit('reservation/setMtechData', {
          markup: {
            type: body.MTechMarkupType,
            value: body.MTechMarkupValue
          }
        })
        // self.$store.commit('booking/setSettingsData', {
        //   timeBuffer: body.D2DTimeBuffer,
        //   markUpPercent: body.D2DMarkupPercent,
        //   arrivalBufferDomestic: body.D2DArrivalDomesticSuggestedMins,
        //   arrivalBufferInternational: body.D2DArrivalInternationalSuggestedMins,
        //   departureBufferDomestic: body.D2DDepartureDomesticSuggestedMins,
        //   departureBufferInternational: body.D2DDepartureInternationalSuggestedMins,
        //   nearByAirportMilesLimit: body.D2DAirportDistanceLimitMiles,
        //   groundLeg1Discount: body.D2DGroundLeg1Discount,
        //   groundLeg2Discount: body.D2DGroundLeg2Discount,
        //   groundLeg3Discount: body.D2DGroundLeg3Discount,
        //   groundLeg4Discount: body.D2DGroundLeg4Discount,
        //   requirePhone: body.D2DPhoneRequire,
        //   sessionTimeout: body.D2DSessionTimeoutSecs,
        //   sessionShowWarning: body.D2DSessionWarningSecs,
        //   forceGroundMiles: body.D2DForceGroundMiles || 0
        // })
        // self.$store.commit('booking/setDepartureData', {
        //   date: moment().add(body.D2DTimeBuffer, 'minutes').add(2, 'days').format('MM/DD/YYYY'),
        //   return: moment().add(body.D2DTimeBuffer, 'minutes').add(9, 'days').format('MM/DD/YYYY'),
        //   isReturning: true
        // })
      })
    }

    if (this.$route & this.$route.name === 'Booking1') {
      this.widgetTab = 'd2d'
      this.$store.commit('other/setOtherData', {widgetTab: 'd2d'})
    }
    if (this.$route.name === 'Booking2') {
      this.widgetTab = 'ground'
      this.$store.commit('other/setOtherData', {widgetTab: 'ground'})
    }
    if (this.$route.name === 'Track') {
      this.widgetTab = 'track'
      this.$store.commit('other/setOtherData', {widgetTab: 'track'})
    }
  },
  mounted () {
    if (['Booking1', 'Booking2', 'Track'].indexOf(this.$route.name) === -1) {
      this.widgetTab = this.$store.state.other.widgetTab
    }

    this.checkShowOnLoad()
    let self = this
    if (self.rsvpData.leg1.pickup.title) {
      self.pickup = self.rsvpData.leg1.pickup.title
      self.pickupText = self.rsvpData.leg1.pickup.title
      self.dropoff = self.rsvpData.leg1.dropoff.title
      self.dropoffText = self.rsvpData.leg1.dropoff.title
    }
    if (self.charter.enabled && self.charter.pickup.title) {
      self.charterLocation.pickup = self.charter.pickup.title
      self.charterLocation.pickupText = self.charter.pickup.title
    }

    self.getAirports()

    if (this.$route.name === 'DriverReview') {
      if (this.getVariable('id') && this.getVariable('fname') && this.getVariable('lname')) {
        let rsvpId = this.getVariable('id')
        let firstName = this.getVariable('fname')
        let lastName = this.getVariable('lname')

        if (document.getElementById('bookingForm')) {
          document.getElementById('bookingForm').querySelector('.widget-loader').style.display = 'none'
        }

        ApiRsvpSearch.search(self, rsvpId, firstName, lastName, res => {
          if (!res.error) {
            self.$store.commit('driverReview/setSearchForm', true)
            self.$store.commit('driverReview/setRsvpParams', { id: rsvpId, firstName, lastName })
            self.$store.commit('driverReview/setDriverInfo', res.provider)
            self.$store.commit('driverReview/setRating', res.rating)
            self.$store.commit('driverReview/showModal', true)
            document.body.classList.add('widget-full')
          }
        })
      }
    }
    window.dispatchEvent(new HashChangeEvent('hashchange'))

    setTimeout(() => {
      if (self.rsvpData.initAirportPickup) {
        if (self.$refs.dropoff) {
          self.$refs.dropoff.focus()
        }
      }
    }, 2500)

    this.session = new WidgetSession(this)

    // if ("geolocation" in navigator) {
    //   if (self._pickup) return
    //   navigator.geolocation.getCurrentPosition(pos => {
    //     // self.getFlightNearestAirport(pos.coords)
    //     let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={LAT}%2C{LNG}&apiKey={API_KEY}&lang=en-US&show=countryInfo'
    //     url = url.replace('{LAT}', pos.coords.latitude)
    //       .replace('{LNG}', pos.coords.longitude)
    //       .replace('{API_KEY}', CONFIG.hereApi.key)
    //     request.get({
    //       url: url,
    //       json: true
    //     }, function (err, res, body) {
    //       self.widgetErrorRemover = err
    //       self.widgetErrorRemover = res
    //       if (body && body.items && body.items.length) {
    //         let result = body.items[0]
    //         let finalResult = {
    //           title: result.title,
    //           address1: result.address.street || result.title,
    //           address2: result.address.houseNumber || result.address.district,
    //           city: result.address.city,
    //           state: result.address.state,
    //           zip: result.address.postalCode,
    //           country: result.address.countryCode,
    //           lat: result.position.lat,
    //           lng: result.position.lng
    //         }
    //         self.$store.commit('reservation/setPickup', {
    //           leg: 'leg1',
    //           value: finalResult
    //         })
    //         self.locationNewValue({
    //           field: 'pickup',
    //           keyInput: finalResult.title || '',
    //           id: result.id || 0,
    //           leg: 'leg1'
    //         })
    //         self.pickup = finalResult.title
    //         self.pickupText = finalResult.title

    //         if (!localStorage.getItem('widgetCurrency')) {
    //           let currCountry = currencyCountry.find(x => x.countryCode === result.countryInfo.alpha2)
    //           if (currCountry) {
    //             if (['INR', 'CAD', 'EUR', 'GBP', 'JPY', 'CNY', 'AUD', 'AED', 'MXN', 'PHP'].indexOf(currCountry.currencyCode) > -1) {
    //               self.currency = currCountry.currencyCode
    //             }
    //           }
    //         }

    //         if (result.countryInfo && result.countryInfo.alpha2) {
    //           self.$store.commit('other/setDefaultData', {country: result.countryInfo.alpha2})
    //         }
    //       }
    //     })
    //   })
    // }

    this.lastPickup = this._pickup
    this.lastDropoff = this._dropoff
  }
}
</script>

<style lang="scss" scoped>
$screen-medium: 64em;
$screen-small: 40em;

.search-box {
  position: relative;
  // top: 100px;

  &.no-tab{
    padding-top: 10px;
  }
}

.widget-new-tab{
  position: absolute;
  top: -65px;
  left: 10px;
  line-height: 1;
  gap: 3px;
  font-size: 15px;
  font-weight: 600;

  .wn-tab{
    background: #333;
    padding: 15px;
    border-radius: 4px 4px 0 0;
    color: #fff!important;
    position: relative;
    cursor: pointer;

    &.active{
      background: #fff;
      color: #697077!important;
      box-shadow: 0px -4px 6px -2px rgba(0, 0, 0, 0.5);
    }
    .tp-msg{
      // display: none;
      position: absolute;
      bottom: calc(100% + 10px);
      width: calc(100% + 80px);
      left: -40px;
      text-align: center;
      background: #fff;
      padding: 4px 8px;
      font-size: 13px;
      line-height: 1.3;
      font-weight: 500;
      border-radius: 10px;
      color: #333;
      visibility: hidden;
      opacity: 0;
      transition: visibility 0s ease-out 0.33s, opacity 0.33s linear;

      &::before{
        content: ' ';
        position: absolute;
        top: 100%;
        left: calc(50% - 5px);
        width: 10px;
        height: 10px;
        border-top: 9px solid #fff;
        border-left: 9px solid transparent;
        border-right: 9px solid transparent;
      }
      &.txt-left{
        text-align: left;
      }
      &.txt-d2d{
        width: calc(100% + 100px);
        padding: 6px 8px;
        left: -50px;

        div{
          margin-bottom: 10px;
          color: #333!important;
        }
      }
      &.active{
        visibility: visible;
        opacity: 1;
        transition-delay: 0s;
      }
    }
  }

  @media only screen and (max-width: $screen-small) {
    left: -10px;
    font-size: 13px;
    line-height: 1.2;
  }
}

.lr-desc {
  height: 40px;
  span{
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    margin: 0 auto;
    display: block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}

.lang-box{
  text-align: right;
  float: right;
  label{
    display: inline-block;
    margin-right: 5px;
    color: #777;
  }
  select{
    width: 100px;
    height: auto;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-right: 10px;
    font-size: 13px;
    color: #555;
  }
}

.widget-tab{
  display: flex;
  background: #f3f3f3;
  border-bottom: 2px solid #e3e3e3;
  box-shadow: 1px 2px 4px rgba(0,0,0, .06);

  div{
    width: 100%;
    text-align: center;
    padding: 10px 0;
    cursor: pointer;
    color: #ccc;
    font-weight: 600;

    i{
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }
    &:hover{
      color: #636669;
    }
  }
  .active, .active:hover{
    color: #2c3e50;
    background: #fff;
  }
  &.disabled{
    div{ cursor: default; }
  }
}

.booking-desc{
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
}

.logo {
  text-align: center;
  margin-bottom: 20px;
  img {
    width: 300px;
  }
}
.abs-center-container {
  position: fixed;
  display: table;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 10px!important;

  .abs-center {
    display: table-cell;
    vertical-align: middle;
  }
  &.show-on-load {
    position: relative;
    display: block;
    padding: 10px 0!important;
    text-align: left;
    
    @media only screen and (max-width: $screen-small) {
      padding: 10px 0;
    }

    .abs-center {
      display: block;
    }
  }
}

.card {
  max-width: 62.5em;
  margin: 0 auto;
}
.column:not(.rsvp-actions) {
  padding: 0 5px;
  margin-bottom: 20px;
}

.quote-error {
  padding: 2px 0 !important;
  margin: 0 0 10px !important;
  text-align: center;
  background: #eb5837;
}

.field-label {
  line-height: 25px;
  font-size: 15px;
}

.box-centered {
  margin: 0 auto;
}

.rsvp-actions {
  text-align: left;

  a {
    font-size: 13px;
    margin: 0 25px 0 5px;
    color: #aaa !important;
    transition: all 0.6s ease-out;

    i {
      margin-right: 5px;
    }
    &:hover {
      text-decoration: underline;
      color: inherit !important;
    }
  }
}

.search-cancel {
  color: #bababa;
  cursor: pointer;

  .fas {
    margin-right: 3px;
  }
}

.search-submit {
  margin-top: 25px;
}
.show-on-load {
  .search-submit {
    margin-top: 10px;
  }
  .rsvp-actions {
    text-align: center;
    a {
      margin: 0 15px;
    }
  }
  .field-label {
    font-weight: 600;
  }
  .rsvp-actions a {
    color: #111 !important;
  }
}

.btn-success{
  text-decoration: none!important;
}

.button-center {
  text-align: center;
  margin-bottom: 0 !important;
  margin-top: 20px;

  .or-div {
    position: relative;
    z-index: 1;

    span {
      position: relative;
      z-index: 2;
      background: #fff;
      padding: 0 10px;
      font-size: 13px;
      font-style: italic;
      color: #333;
    }
    &::before {
      content: " ";
      border-top: 1px solid #ddd;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 0;
      height: 1px;
      z-index: 1;
    }
  }
  .old-booking {
    font-size: 13px;
    margin-top: 5px;
    display: inline-block;
  }
  &.corporate {
    margin-top: 10px;

    span {
      margin-top: 5px;
    }
  }
}

.field-text{
  &[readonly='readonly']{ cursor: pointer; }
  &.disabled{
    background: #eee;
  }
}

.global-auth-box{
  margin-bottom: 10px;
  text-align: center;
  padding: 0 20px;
  color: #eee;

  a{
    cursor: pointer;
    font-weight: 600;
    color: #ff9c09;
  }
  .w-heading{
    font-size: 24px;
    font-weight: 600;
  }
  .date-option{
    label{
      margin-right: 20px;
    }
    input{
      margin-right: 5px;
    }
  }
  .user-actions{
    b{
      color: #ff9c09;
      cursor: pointer;
    }
  }
}
.gl-logged-in{
  position: relative;

  .gl-option-trigger{
    cursor: pointer;
  }
  .fas{
    font-size: 18px;
    color: #ff9c09;
    margin-left: 5px;
  }
  .gl-options{
    position: absolute;
    top: 100%;
    right: 0;
    width: 180px;
    letter-spacing: .6px;
    background: #fafafa;
    border-radius: 0 0 4px 4px;
    overflow: hidden;
    z-index: 2;

    div{
      color: #333;
      border-bottom: 1px solid #ccc;
      line-height: 1;
      padding: 7px 10px;
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;

      &.logout{
        color: #fa5656;
      }
      &:hover{
        background: #dee9f0;
      }
      &:last-child{
        border: none;
      }
    }
  }
}

.new-top{
  gap: 30px;
  font-size: 16.5px;
  
  .nt-parent{
    padding: 0 10px;
  }
  .mob-order-3{
    gap: 20px;
  }
  
  select{
    font-size: 16px;
    width: auto;
    height: 30px;
    border: none;
    outline: none;

    &.currency{
      border: 1px solid #888;
      background: #fff;
      padding: auto 10px;
    }
  }
  a{
    cursor: pointer;
    font-weight: 600;
    color: #ff9c09;
  }
  .user-actions{
    b{
      color: #ff9c09;
      cursor: pointer;
    }
  }
  .logout{
    color: #fa5656;
    font-size: 12px;
    margin-right: 10px;
  }
}
.margin-l-a{
  margin-left: auto;
}
.row.full-width{
  max-width: 100%!important;
}
.search-field-box{
  gap: 7px;
  margin-bottom: 20px;
  padding: 0;

  .field-group{
    min-width:140px;
  }
  .field-group.full-width{
    width: 100%;
    max-width: 390px;
  }
  .field-text{
    margin: 0;
    width: 100%;
    max-width: 160px;
    min-width: 130px;
  }
  .search-submit{
    width: 130px;
    min-width: 130px;
    text-align: center;
    margin-top: 0;
  }
}
.reverse-loc{
  border: 1px solid #ccc;
  height: 40px;
  line-height: 40px;
  padding:0 10px;
  background: #f7f1e9;
  &:hover{
    background: #fff6ea;
    cursor: pointer;
    color: #d3841b;
  }
}

.corporate-login-signup {
  font-size: 13px;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-100px);
  opacity: 0;
}
.slide-down-small-enter-active,
.slide-down-small-leave-active {
  transition: all 0.3s ease;
}
.slide-down-small-enter,
.slide-down-small-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}

.welcome-txt{
  .user-x{
    text-decoration: underline;
  }
  .user-x, .mng-flights{
    color: #ff9c09;
    cursor: pointer;
  }
  .mng-flights{
    margin-left: 20px;
  }
  .logout{
    display: none;
  }
}
.mng-flights{
  i{
    color: #333!important;
    margin-right: 2px;
    font-size: 13px;
    vertical-align: 2px;
  }
}
.lr-desc-mobile{
  display: none!important;
}

@media only screen and (max-width: 641px) {
  .card .medium-5.column {
    margin-bottom: 10px;
  }
  .search-submit {
    margin-top: 10px;
  }
  .lr-desc-mobile{
    display: inherit!important;
  }
  .lr-desc{
    height: auto!important;
    display: none;

    .lang-box{
      float: none!important;
    }
    span{
      position: relative;
      left: 0;
      transform: none!important;
    }
  }
  .desktop-mode, .hide-in-mobile{
    display: none;
  }

  .new-top.nt-parent{
    flex-direction: column;
    gap: 20px;

    .new-top{
      flex-direction: column;
      gap: 0;
    }
    .mob-order-1{
      order: 1;
      display:none!important;
    }
    .mob-order-3{
      order: 3;
      width: 100%;
      padding: 0 10px;

      select{
        border: 1px solid #888;
        padding: 5px;
        width: 100%;
      }
    }
    .logout{
      display: none;
    }
    .welcome-txt{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 10px 15px 0;

      .mng-flights{
        display: none;
      }
      .logout{
        display: block;
        font-size: 15px;
        margin-right: 0;
      }
    }
  }
  .lr-desc-mobile{
    display: flex;
    order: 2;
    width: 100%;
    padding: 6px 10px;

    select{
      border: 1px solid #888;
    }

    .mobile-acc-box{
      span{
        display: inline-block;
        margin: 0 4px

      }
    }
  }
  .search-field-box{
    flex-direction: column;

    .reverse-loc{
      margin: 0 auto;
    }
    .field-group {
      width: 100%;
      input{
        max-width: 100%;
      }
    }
    .search-submit{
      width: 100%;
    }
  }
}
@media only screen and (max-width: 640px) {
  .show-on-load {
    padding-bottom: 0;
    .rsvp-actions {
      margin-top: 0 !important;
      a {
        display: block;
      }
      a:last-child {
        margin-top: 15px;
      }
    }
  }
  .next-line-mobile {
    display: block;
  }
  .global-auth-box{
    flex-direction: column-reverse;
    
    .gl-col{
      width: 100%;
      text-align: center!important;

      &:nth-child(2){
        margin-bottom: 20px;
      }
    }
    .date-option{
      justify-content: space-around!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?09beb33e